import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[pcsDndPlaceholder]'
})
export class DndPlaceholderDirective {
  constructor(public elementRef: ElementRef) {
  }
}
